import { useMutation } from "@tanstack/react-query";
import { saveGoogleAdsMappings } from "../../api/bGoogleAdsApi";

export const useSaveGoogleAdsMappings = () => {
  return useMutation({
    mutationKey: ["save-google-ads-mappings"],
    mutationFn: (data) => saveGoogleAdsMappings(data),
    onError: (error) => {
      console.error("Google Ads mapping save error:", error.response || error);
    },
  });
};
